export const FORM_CATEGORIES = [
  { value: 'fire_safety', label: 'Fire Safety' },
  { value: 'building_safety', label: 'Building Safety' },
  { value: 'asbestos_hazardous', label: 'Asbestos & Hazardous Materials' },
  { value: 'water_hygiene', label: 'Water Hygiene / Legionella' },
  { value: 'ppm_statutory', label: 'PPM & Statutory Inspections' },
  { value: 'general_health_safety', label: 'General Health & Safety' },
  { value: 'incident_management', label: 'Incident & Near Miss' },
  { value: 'contractor_management', label: 'Contractor Management' },
  { value: 'accessibility', label: 'Accessibility & Equality' },
  { value: 'environmental', label: 'Environmental & Sustainability' },
  { value: 'regulatory_legal', label: 'Regulatory & Legal Compliance' },
  { value: 'tenancy_lifecycle', label: 'Property / Tenancy Lifecycle' },
  { value: 'periodic_audits', label: 'Periodic Audits & Site Inspections' }
]

const LABEL_BY_VALUE = FORM_CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c.label
  return acc
}, {})

export const getCategoryLabel = value => (value ? LABEL_BY_VALUE[value] || value : null)
